/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectAllocationInfoDtoFromJSON, ProjectAllocationInfoDtoToJSON, } from './ProjectAllocationInfoDto';
/**
 * Check if a given object implements the MonthlyAllocationSummaryDto interface.
 */
export function instanceOfMonthlyAllocationSummaryDto(value) {
    return true;
}
export function MonthlyAllocationSummaryDtoFromJSON(json) {
    return MonthlyAllocationSummaryDtoFromJSONTyped(json, false);
}
export function MonthlyAllocationSummaryDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'month': json['month'] == null ? undefined : json['month'],
        'year': json['year'] == null ? undefined : json['year'],
        'isConsolidated': json['isConsolidated'] == null ? undefined : json['isConsolidated'],
        'projects': json['projects'] == null ? undefined : (json['projects'].map(ProjectAllocationInfoDtoFromJSON)),
        'totalAllocationDays': json['totalAllocationDays'] == null ? undefined : json['totalAllocationDays'],
    };
}
export function MonthlyAllocationSummaryDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'month': value['month'],
        'year': value['year'],
        'isConsolidated': value['isConsolidated'],
        'projects': value['projects'] == null ? undefined : (value['projects'].map(ProjectAllocationInfoDtoToJSON)),
        'totalAllocationDays': value['totalAllocationDays'],
    };
}
